export const SALARY_TYPES_MODALS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit',
};

export const DEFAULT_SALARY_TYPE = {
  _id: '',
  name: '',
  salaryTypeNumber: 0,
  createdBy: '',
  companyId: '',
  createdAt: '',
};
